export default function statusDoc(status){
  if (status){
    return 'Доставлено'
  }
  else return 'Заказано'
}